import { MESSAGE_STATUS } from "@/helpers/constants";

export default {
  publishedAnnouncements: state => {
    return state.announcements
      .filter(m => m.messageStatus !== MESSAGE_STATUS.DRAFT)
      .sort((a, b) => new Date(b.updatedAt || b.createdAt) - new Date(a.updatedAt || a.createdAt));
  },
  draftAnnouncements: state => {
    return state.announcements
      .filter(m => m.messageStatus === MESSAGE_STATUS.DRAFT)
      .sort((a, b) => new Date(a.updatedAt || a.createdAt) - new Date(b.updatedAt || b.createdAt));
  }
};
